import React from "react";
import "./Hero.css";

export const Hero = () => {
  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const headerOffset = 140;
      const elementPosition = el.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: prefersReducedMotion ? "auto" : "smooth"
      });
    }
  };

  return (
    <section id="home" className="hero" aria-labelledby="hero-heading">
      <div className="hero-content">
        <h1 id="hero-heading" className="motto">"Your Dog's Other Best Friend"</h1>
        <p className="hero-subhead">VIP Dog Walking, Boarding, and Pet Waste Removal Services in North Central Austin, TX.</p>
        <div className="hero-buttons">
          <button type="button" className="btn-primary" onClick={() => scrollToId("contact")}>
            Schedule Service
          </button>
          <a href="#services" className="btn-secondary" onClick={(e) => { e.preventDefault(); scrollToId("services"); }}>
            Learn More
          </a>
        </div>
      </div>
      <div className="hero-image">
        <img src="/hero.webp" alt="Happy Dog" className="hero-img" />
      </div>
    </section>
  );
};
